import { render, staticRenderFns } from "./card.vue?vue&type=template&id=5a3285d6&scoped=true"
var script = {}
import style0 from "./card.vue?vue&type=style&index=0&id=5a3285d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3285d6",
  null
  
)

export default component.exports